import { Flex, Box } from "@chakra-ui/react";
import { Lottie } from "src/components/Lottie";
import { useTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";

export default function NoNearbyDevices({ openManualPairingButton }) {
  const { t } = useTranslation();
  return (
    <Flex height="100%" flexDirection="column" alignItems="center">
      <Flex
        flex="1 1 auto"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
      >
        <Lottie
          animationName="looking-for-devices.json"
          delay={500}
          width="176px"
          height="128px"
        />
        <H2 width="320px" mt="24px" textAlign="center" color="highEmphasis">
          {t("pairing.requester.nearbyDevices.noDevices.heading")}
        </H2>
        <BodyText
          width="320px"
          mt="8px"
          textAlign="center"
          color="mediumEmphasis"
        >
          {t("pairing.requester.nearbyDevices.noDevices.text")}
        </BodyText>
      </Flex>
      <Box mb="24px" flex="0 0 auto">
        {openManualPairingButton}
      </Box>
    </Flex>
  );
}
